export function getLibraryPath(path: string): string | null {
  const librarySlug = path.split("/").filter(Boolean)[0];
  return librarySlug ? `/${librarySlug}` : null;
}
